module.exports = __webpack_public_path__ + "img/userLogo13.6308dd47.jpg";